const STATION_PRINT_KEY = "printing_station";

export type PrintingStation = string | null;

export function getSavedStation(): PrintingStation {
    if (typeof window === "undefined") return null;
    const raw = localStorage.getItem(STATION_PRINT_KEY);
    if (!raw) return null;
    const value = raw.trim();
    return value.length > 0 ? value : null;
}

export function saveStation(station: string) {
    if (typeof window !== "undefined") {
      const value = station.trim();
      if (value) {
        localStorage.setItem(STATION_PRINT_KEY, value);
      } else {
        localStorage.removeItem(STATION_PRINT_KEY);
      }
    }
}